import * as React from 'react';

import { trackLeaveFeedbackClick } from '../../tracking';
import * as styles from './styles/styles.css';

interface ITextWithLinkProps {
  onClick(): void;
  isLeadFactory: boolean;
}

export function TextWithLink({ onClick, isLeadFactory }: ITextWithLinkProps) {
  const handleClick = () => {
    trackLeaveFeedbackClick();

    onClick();
  };

  if (isLeadFactory) {
    return (
      <p className={styles['description']}>
        Пожалуйста, <a href="#" onClick={handleClick}>оставьте отзыв</a> после звонка
      </p>
    );
  }

  return (
    <p className={styles['description']}>
      Пожалуйста, скажите, что нашли это объявление на ЦИАН.
       И <a href="#" onClick={handleClick}>оставьте отзыв</a> после звонка
    </p>
  );
}
